import Environment from "../environment";

import Api from './ApiService';
import { AuthService } from './AuthService';

import User from "../models/User";


export const UserService = {
    register: (data) => {
        console.log(data);
        return new Promise((resolve, reject) => {
            return Api.fetchNoToken(`${Environment.api}api/auth/register/`, 'POST', data
                ).then(data => {
                    resolve(new User(data));
                }).catch((error) => {
                    reject(error);
                }
            );
        });
    },

    resendMail: (data) => {
        return new Promise((resolve, reject) => {
            return Api.fetchNoToken(`${Environment.api}api/usuarios/resend_email/`, 'POST', data
                ).then(data => {
                    resolve();
                }).catch((error) => {
                    reject(error);
                }
            );
        });
    },

    resetPassword: (data) => {
        return new Promise((resolve, reject) => {
            return Api.fetchNoToken(`${Environment.api}api/usuarios/password-reset`, 'PUT', data
                ).then(data => {
                    resolve();
                }).catch((error) => {
                    reject(error);
                }
            );
        });
    },

    requestPassword: (data) => {
        return new Promise((resolve, reject) => {
            return Api.fetchNoToken(`${Environment.api}api/usuarios/password-request`, 'PUT', data
            ).then(data => {
                resolve();
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },

    resetConfirm: (data) => {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };

        return fetch(`${Environment.api}api/usuarios/password-reset`, requestOptions)
            .then(response => {
                if (response.ok) {
                    return response.json().then(data => {
                        localStorage.setItem('access', data.access);
                        localStorage.setItem('refresh', data.refresh);
                        return data;
                    });
                }
                throw response;
            });
    },

    unsubscribeRequest: () => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthService.getToken()
            }
        };
        return fetch(`${Environment.api}api/usuarios/solicitud-baja/`, requestOptions)
            .then(response => {
                if (response.ok) {
                    return response.json().then(data => {
                        localStorage.setItem('message', data.message);
                        localStorage.setItem('user', data.user);
                        return data;
                    });
                }
                throw response;
            });
    },

    confirmUnsubscribe: (token) => {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: token })
        };

        return fetch(`${Environment.api}api/usuarios/baja/`, requestOptions)
            .then(response => {
                if (response.ok) {
                    return response.json().then(data => {
                        localStorage.setItem('message', data.message);
                        AuthService.logout();
                        return data;
                    });
                }
                throw response;
            });
    },

    update: (data) => {
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': AuthService.getToken()
            },
            body: JSON.stringify(data)
        };

        let user = AuthService.currentUserValue();
        console.log(user);

        return fetch(`${Environment.api}api/usuarios/`+user.id, requestOptions)
            .then(response => {
                if (response.ok) {
                    return response.json().then(data => {
                        localStorage.setItem('message', data.message);
                        localStorage.setItem('user', data.user);
                        return data;
                    });
                }
                throw response;
            });
    },
}
